<div class="container-fluid">


  <div class="row justify-content-center mb-3">
    <div class="col-12">
      <h5 class="q-bo-grouptitle">
        <div style="display: flex; justify-content: space-between;">
          <span>{{model.Conx_PER.key}}</span> 
          <a href='{{model.lienExtranet}}' target='_blank'><i class="fa-sign-in-alt fas" title="Accéder à l'Extranet"></i></a>
        </div>
      </h5>
      <div class="w-100 q-grey" style="min-height: 25px; cursor: not-allowed;">{{model.Conx_PER.value}}</div>      
    </div>
  </div>

  <div class="row justify-content-center mb-3">
    <div class="col-12">
      <div class="q-bo-grouptitle mb-2">
        <span>{{model.PassePER.key}}</span>
        <span class="q-text-s q-c-main q-bold"> (numérique)</span>
      </div>
      <div class="w-100 q-grey" style="min-height: 25px; cursor: not-allowed;">{{model.PassePER.value}}</div>
    </div>
  </div>

  <div class="row justify-content-center mb-3">
    <div class="col-12">
      <h5 class="q-bo-grouptitle">{{model.Role_PER.key}}</h5>
      <select id="Role_PER"
              class="w-100 q-main-select mb-2"
              [(ngModel)]="model.Role_PER.value">
        <option *ngFor="let option of model.ComboRole_PER | keyvalue" [value]="option.value">{{option.key}}</option>
      </select>
    </div>
  </div>

  <div class="row justify-content-center mb-3">
    <div class="col-12">
      <h5 class="q-bo-grouptitle">{{model.NeproPER.key}}</h5>
      <div class="d-flex w-100">
        <input id="NeproPER" type="text"
               class="col q-input-border q-bo"
               [(ngModel)]="model.NeproPER.value" disabled>
        <!--<button class="col-auto q-btn q-white mr-0 ml-2"
                style="height: 30px;padding: 0;"
                title="Envoyer les identifiants par mail."
                (click)="SendMail()" [disabled]="!model.NeproPER.value">
          <i [ngClass]="[sendingMail ? 'fas fa-spin fa-pulse fa-spinner' :'fas fa-paper-plane']"></i>
        </button>-->
      </div>
    </div>
  </div>

  <div class="row justify-content-center">
    <div class="d-flex col-12 justify-content-end">
      <div><i *ngIf="isSaving" class="fas fa-spin fa-spinner fa-pulse mr-2 q-c-main"></i></div>
      <button class="q-btn q-danger" (click)="OnCancel()" [disabled]="isSaving">Supprimer</button>
      <button class="q-btn q-main mr-0" (click)="OnSave()" [disabled]="isSaving">{{model.PassePER.value ? 'Valider' : 'Générer'}}</button>
    </div>
  </div>

</div>
